import { useTranslation } from "react-i18next";

export default function CruisePassengerNationality({ item }) {
  const { t } = useTranslation();

  const country = item.countryName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  return (
    <div className="relative group w-max cursor-pointer text-center">
      <span className="flex items-center gap-1">
        {t(item.nationality)}
        <i className={`${t(country)} flag`} />
      </span>
      <div class="z-10 absolute w-auto left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none">
        {t(item.countryName)}
      </div>
    </div>


  );
};
